export enum ThemeSetting {
  // Customizer const
  THEME_TYPE = 'THEME_TYPE',
  THEME_TYPE_LITE = 'THEME_TYPE_LITE',
  THEME_TYPE_DARK = 'THEME_TYPE_DARK',
  THEME_TYPE_SEMI_DARK = 'THEME_TYPE_SEMI_DARK',

  THEME_COLOR = 'THEME_COLOR',

  HORIZONTAL_NAVIGATION = 'HORIZONTAL_NAVIGATION',

  HORIZONTAL_MENU_POSITION = 'HORIZONTAL_MENU_POSITION',
  ABOVE_THE_HEADER = 'ABOVE_THE_HEADER',
  INSIDE_THE_HEADER = 'INSIDE_THE_HEADER',
  BELOW_THE_HEADER = 'BELOW_THE_HEADER',

  VERTICAL_NAVIGATION = 'VERTICAL_NAVIGATION',
  NAV_STYLE_MINI = 'NAV_STYLE_MINI',

  LAYOUT_TYPE = 'LAYOUT_TYPE',

  LAYOUT_TYPE_FRAMED = 'LAYOUT_TYPE_FRAMED',
  LAYOUT_TYPE_BOXED = 'LAYOUT_TYPE_BOXED',
  LAYOUT_TYPE_FULL = 'LAYOUT_TYPE_FULL',

  NAV_STYLE = 'NAV_STYLE',

  NAV_STYLE_FIXED = 'NAV_STYLE_FIXED',
  NAV_STYLE_MINI_SIDEBAR = 'NAV_STYLE_MINI_SIDEBAR',
  NAV_STYLE_DRAWER = 'NAV_STYLE_DRAWER',
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR = 'NAV_STYLE_NO_HEADER_MINI_SIDEBAR',
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR = 'NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR',

  NAV_STYLE_DEFAULT_HORIZONTAL = 'NAV_STYLE_DEFAULT_HORIZONTAL',
  NAV_STYLE_DARK_HORIZONTAL = 'NAV_STYLE_DARK_HORIZONTAL',
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL = 'NAV_STYLE_INSIDE_HEADER_HORIZONTAL',
  NAV_STYLE_BELOW_HEADER = 'NAV_STYLE_BELOW_HEADER',
  NAV_STYLE_ABOVE_HEADER = 'NAV_STYLE_ABOVE_HEADER',

  LIGHT_PURPLE = 'light_purple',
  LIGHT_PURPLE_SEC = '#00B378',
  LIGHT_PURPLE_DARK_TEXT_COLOR = '#9799AC',

  RED = 'red',
  RED_SEC = '#00D9C9',
  RED_DARK_TEXT_COLOR = '#878BAB',

  BLUE = 'blue',
  BLUE_SEC = '#FCB53B',
  BLUE_DARK_TEXT_COLOR = '#AAA59A',

  DARK_BLUE = 'dark_blue',
  DARK_BLUE_SEC = '#17BDE5',
  DARK_BLUE_DARK_TEXT_COLOR = '#9DDAE9',

  ORANGE = 'orange',
  ORANGE_SEC = '#F1D065',
  ORANGE_DARK_TEXT_COLOR = '#ABA895',

  LIGHT_BLUE = 'light_blue',
  LIGHT_BLUE_SEC = '#59DCFF',
  LIGHT_BLUE_DARK_TEXT_COLOR = '#92A2C8',

  DEEP_ORANGE = 'deep_orange',
  DEEP_ORANGE_SEC = '#70A288',
  DEEP_ORANGE_DARK_TEXT_COLOR = '#97B8C7',

  LIGHT_PURPLE_1 = 'light_purple_1',
  LIGHT_PURPLE_1_SEC = '#E14594',
  LIGHT_PURPLE_1_DARK_TEXT_COLOR = '#8288B4',

  LIGHT_PURPLE_2 = 'light_purple_2',
  LIGHT_PURPLE_2_SEC = '#64D7D6',
  LIGHT_PURPLE_2_DARK_TEXT_COLOR = '#5782BB',

  TAB_SIZE = 992,
}
